import { render, staticRenderFns } from "./UserInviteTab2.vue?vue&type=template&id=02b4fea8&scoped=true"
import script from "./UserInviteTab2.vue?vue&type=script&lang=js"
export * from "./UserInviteTab2.vue?vue&type=script&lang=js"
import style0 from "./UserInviteTab2.vue?vue&type=style&index=0&id=02b4fea8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b4fea8",
  null
  
)

export default component.exports